<div class="border-0 px-4 py-1 scroll-container" ref="manage_risk_framework">
  <NavigationBackButton/>
  <!-- Risk Framework Assessments -->
  <div class="card-header card-header-primary shadow rounded-lg mt-2">
      <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs" data-tabs="tabs">
          <li class="rounded-lg me-2 nav-item">
            <a class="text-dark-blue text-decoration-none fs-5 fw-bold nav-link" href="#profile" data-toggle="tab">
              <span><i class="bi bi-exclamation-triangle fs-4 me-2"></i></span>Manage Risk Framework Assessments
            </a>
          </li>
        </ul>
        <div class="d-flex flex-row gap-2 ms-3 justify-content-end mb-1">
        <button
            v-if="risk_types.length"
            class="btn btn-primary-dark btn-sm text-xxs shadow"
            data-bs-toggle="modal"
            data-bs-target="#create_risk_framework_modal"
        >
            Create Risk Framework
        </button>
        <button
        v-if="risk_frameworks.length"
        class="btn btn-primary-dark btn-sm text-xxs shadow "
        data-bs-toggle="modal"
        data-bs-target="#assign_risk_framework_modal"
      >
        Assign to Entity
      </button>
    </div>
      </div>
    </div>
  </div>

  <div class="card rounded-lg border-0 shadow mt-2">
    
    <div class="card-body">
      <GlobalTable
        :key="risk_frameworks.length"
        :headers="['ID', 'Type', 'Risk Framework', 'Description', 'Is_Active']"
        :data="risk_framework_table_data"
        table_id="risk_framework_table"
      >
        <template #id="{ row }">
            {{ row.id }}
          </template>
          <template #type="{ row }">
            {{ row.type }}
          </template>

          <template #risk_framework="{ row }">
            {{ row.risk_framework }}
          </template>

          <template #description="{ row }">
            {{ row.description }}
          </template>

          <template #actions="{ row, index }">
            <button
              class="btn btn-primary-dark btn-sm rounded-3 small shadow me-2 text-xxs"
              @click="redirect_to_manage_risk_questions(row.id)"
            >
              Manage
            </button>
            <button
            class="btn btn-sm rounded-3 shadow text-xxs"
            :class="row.is_active ? 'btn-primary-dark' : 'btn-primary-dark'"
            @click="toggle_risk_framework(row)"
          >
            {{ row.is_active ? 'Deactivate' : 'Activate' }}
          </button>

          </template>
      </GlobalTable>
    </div>
  </div>

  <!-- Create Risk Framework Modal -->
  <teleport to="body">
    <div id="create_risk_framework_modal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <h6 class="modal-title text-white text-xxs">Create Risk Framework</h6>
            <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body d-flex flex-column flex-grow-1 overflow-auto">
            <div class="mb-3">
              <label class="form-label text-xxs">Select Risk Type</label>
              <select
                v-model="new_risk_framework.risk_framework_type_id"
                class="form-select text-xxs"
              >
                <option disabled value="">Please select</option>
                <option
                  v-for="type in risk_types"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.risk_type }}
                </option>
                <option value="other">Other</option>
              </select>
            </div>
            <div v-if="new_risk_framework.risk_framework_type_id === 'other'" class="mb-3">
                <label class="form-label text-xxs">New Risk Type Name</label>
                <input
                  v-model="new_risk_framework.new_type_name"
                  type="text"
                  class="form-control text-xxs"
                  placeholder="Enter a new risk type"
                />
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs">Risk Name</label>
              <input
                v-model="new_risk_framework.risk_assessment"
                type="text"
                class="form-control text-xxs"
                placeholder="e.g. High Exposure"
              />
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs">Risk Description</label>
              <textarea
                v-model="new_risk_framework.description"
                class="form-control text-xxs"
                placeholder="Describe this framework"
              ></textarea>
            </div>
            <div class="mb-3">
              <label class=" form-label text-xxs">Assessment Phase</label>
              <select v-model="new_risk_framework.assessment_phase" class="form-select text-xxs">
                <option disabled value="">Please select</option>
                <option value="pre">Pre-Assessment</option>
                <option value="post">Post-Assessment</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xxs"
              @click="create_risk_framework"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Assign Risk Framework Modal -->
  <teleport to="body">
    <div v-show="assignment_payload" class="modal fade" id="assign_risk_framework_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h4 class="modal-title text-sm fw-bold">Assign Risk Framework</h4>
          <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="text-xxs">Select Framework</label>
            <select v-model="assignment_payload.assessment_id" class="form-select text-xxs">
              <option disabled value="">Please select</option>
              <option v-for="framework in risk_frameworks" :key="framework.id" :value="framework.id">
                {{ framework.risk_assessment }}
              </option>
            </select>
          </div>
          <div class="form-group mt-2">
            <label class="text-xxs">Select Entity</label>
            <div v-for="entity in entities" :key="entity.id" class="form-check text-xxs">
              <input
                class="form-check-input"
                type="checkbox"
                :value="entity.id"
                v-model="selected_entity_ids"
              />
              <label class="form-check-label" :for="'entity_' + entity.id">
                {{ entity.entity_type_name }}
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-primary text-xxs" @click="assign_framework_to_entity">
            Assign
          </button>
        </div>
      </div>
    </div>
  </div>
  </teleport>

</div>